import { render } from "./ChatShowImg.vue?vue&type=template&id=62203e04"
import script from "./ChatShowImg.vue?vue&type=script&lang=js"
export * from "./ChatShowImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__